import {create} from 'zustand';
import {getUser, login} from './ApiHelper';
import {PayoutUser} from './types';
import LedgerStore from './LedgerStore';
import DataStore from './DataStore';

export interface LoginStore {
  loading: boolean;
  hasErrors: boolean;
  errorMessage: string;
  loggedIn: boolean;
  loggingIn: boolean;
  user: PayoutUser | null;
  login: (username: string, password: string) => Promise<void>;
  logout: () => Promise<void>;
  refresh: (loggingIn?: boolean) => Promise<void>;
}

const UseLoginStore = create<LoginStore>((set, get) => {
  return {
    loading: true,
    hasErrors: false,
    errorMessage: '',
    loggedIn: false,
    loggingIn: false,
    user: null,

    refresh: async (isLoginFlow = false) => {
      const loadingKey = isLoginFlow ? 'loggingIn' : 'loading';
      set(() => ({[loadingKey]: true}));
      try {
        const user = await getUser();
        set(() => ({user, [loadingKey]: false, loggedIn: true}));
      } catch (err: any) {
        set(() => ({hasErrors: false, [loadingKey]: false, loggedIn: false, user: null}));
        throw err;
      }
    },

    login: async (username: string, password: string) => {
      set(() => ({loggingIn: true}));
      try {
        const response = await login(username, password);
        await get().refresh(true);
        set(() => ({user: response, loggingIn: false, loggedIn: true}));
      } catch (err: any) {
        set(() => ({hasErrors: true, loggingIn: false, loggedIn: false, user: null, errorMessage: `${err}`}));
        throw err;
      }
    },

    logout: async () => {

      set(() => ({
        loading: false,
        hasErrors: false,
        errorMessage: '',
        loggedIn: false,
        loggingIn: false,
        user: null,
      }));

      LedgerStore.getState().reset();
      DataStore.getState().reset();
    },
  };
});
export default UseLoginStore;
